import { ArticleHeading1, ArticleParagraph1 } from '@cian/ui-kit';
import { useIsDesktop } from '@cian/valuation-utils-component';

import { AccordionRoot, AccordionItem } from '../../packages/Accordion';
import { content } from './content';
import { Wrapper } from '../Wrapper';

import * as styles from './styles.css';

export const Faq: React.FC = () => {
  const isDesktop = useIsDesktop();

  return (
    <div className={styles['container']}>
      <Wrapper>
        <div className={styles['title']}>
          <ArticleHeading1>Часто задаваемые вопросы</ArticleHeading1>
        </div>
        <AccordionRoot isTwoColumn={isDesktop}>
          {content.map((item, index) => {
            return (
              <AccordionItem key={index} title={item.title}>
                <ArticleParagraph1>{item.text}</ArticleParagraph1>
              </AccordionItem>
            );
          })}
        </AccordionRoot>
      </Wrapper>
    </div>
  );
};

Faq.displayName = 'Faq';
